import { Tab, Tabs } from 'react-bootstrap';
import { getAccounts, getSubgroup } from '../../../api/ledgers';
import {
  AlertDefaultError,
  PermissionsGate,
} from '../../../components/PermissionsGate';
import PrimaryAsyncSelect from '../../../components/PrimaryAsyncSelect';
import PrimaryDataTable from '../../../components/PrimaryDataTable';
import PrimaryDatePicker from '../../../components/PrimaryDatePicker';
import '../../../globalStyles/css/bootstrap/bootstrap.min.css';
import { generalLedgerCol } from '../const';
import '../ledger.css';

const minDate = '2022-12-01';

const GeneralLedgerReportScreen = ({
  // handleChange,
  formData,
  dateChange,
  onSearch,
  generalLedgerData,
  selectedTab,
  handleSearch,
  handleSelectedTab,
  handleChange,
  handleDataTableChange,
  handleFilterModelChange,
  handleTableChange,
  loading,
  totalRow,
  reloadTable,
  handleExport,
  columnRunning,
  onHandlegeneralLedgerExport,
  onHandleGlExportDownload,
  isExporting,
  exportProgress,
  glLastUpdated,
}) => {
  return (
    <div className="container-fluid" style={{ padding: 30 }}>
      {isExporting && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: 12,
              padding: '32px 40px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 16,
              minWidth: 340,
              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            }}
          >
            <div
              className="spinner-border text-success"
              style={{ width: 48, height: 48 }}
              role="status"
            />
            <span style={{ fontSize: 16, fontWeight: 600, color: '#333' }}>
              {exportProgress >= 100
                ? 'Downloading your export. This will close automatically.'
                : 'Exporting, please wait...'}
            </span>
            <div style={{ width: '100%' }}>
              <div className="progress" style={{ height: 10, borderRadius: 6 }}>
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                  role="progressbar"
                  style={{ width: `${exportProgress}%` }}
                />
              </div>
              <div
                style={{
                  textAlign: 'center',
                  marginTop: 6,
                  fontSize: 18,
                  color: '#555',
                }}
              >
                {exportProgress}%
              </div>
            </div>
            <div
              style={{
                fontSize: 13,
                color: '#444',
                textAlign: 'center',
                lineHeight: 1.7,
              }}
            >
              {glLastUpdated ? (
                <>
                  <div>
                    This GL export includes data up to{' '}
                    <strong>{glLastUpdated}</strong> only.
                  </div>
                  <div>
                    Any data or changes after <strong>{glLastUpdated}</strong>{' '}
                    are not included.
                  </div>
                </>
              ) : (
                <div>Loading data availability info...</div>
              )}
            </div>
          </div>
        </div>
      )}
      <h4 className="headline">GENERAL LEDGERS</h4>
      <br />
      <Tabs
        id="controlled-tab-example"
        activeKey={selectedTab}
        onSelect={(k) => handleSelectedTab(k)}
        className="default-tab"
      >
        <Tab
          className="default-tab-content"
          eventKey="general_ledger"
          title="General Ledger"
        >
          <div className="col-md-12">
            <PermissionsGate scopes={['get_general_ledger']}>
              <div className="row">
                <div className="col-md-4">
                  <label>Select Account</label>

                  <PrimaryAsyncSelect
                    onChange={(e) =>
                      handleChange({
                        target: { name: 'account_code', value: e.value },
                      })
                    }
                    customFunction={getAccounts}
                    isClearable={true}
                    name={'account_name'}
                    value={formData.account_code}
                    placeholder="Select Account"
                    config={{
                      searchField: 'keyword',
                      valueField: 'account_code',
                      labelField: 'account_name',
                    }}
                  />
                </div>
                {/* <div className="col-md-4">
                  <label>Select FS Group</label>

                  <PrimaryAsyncSelect
                    onChange={(e) =>
                      handleChange({
                        target: { name: 'fs_group', value: e.value },
                      })
                    }
                    customFunction={getFSGroup}
                    isClearable={true}
                    name={'name'}
                    value={formData.fs_group}
                    placeholder="Select FS Group"
                    config={{
                      searchField: 'keyword',
                      valueField: 'fs_group',
                      labelField: 'name',
                    }}
                  />
                </div> */}
                <div className="col-md-4">
                  <label>Select Subgroup</label>

                  <PrimaryAsyncSelect
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: 'sub_group',
                          value: e.value,
                        },
                      })
                    }
                    customFunction={getSubgroup}
                    isClearable={true}
                    name={'name'}
                    value={formData.sub_group}
                    placeholder="Select Subgroup"
                    config={{
                      searchField: 'keyword',
                      valueField: 'sub_group',
                      labelField: 'name',
                    }}
                  />
                </div>
              </div>
              <div
                className="row align-items-end"
                style={{ marginTop: '20px', marginBottom: '16px' }}
              >
                <div className="col-md-2">
                  <label>Date From</label>
                  <label className="req">*</label>
                  <PrimaryDatePicker
                    name={'date_from'}
                    datePickerFormat={'yyyy-MM-dd'}
                    datePickerFormatString={'YYYY-MM-DD'}
                    value={formData.date_from}
                    onChange={(date) =>
                      dateChange({
                        target: { name: 'date_from', value: date },
                      })
                    }
                    minDate={minDate}
                  />
                </div>
                <div className="col-md-2">
                  <label>Date To</label>
                  <label className="req">*</label>
                  <PrimaryDatePicker
                    name={'date_to'}
                    datePickerFormat={'yyyy-MM-dd'}
                    datePickerFormatString={'YYYY-MM-DD'}
                    value={formData.date_to}
                    onChange={(date) =>
                      dateChange({
                        target: { name: 'date_to', value: date },
                      })
                    }
                    minDate={minDate}
                  />
                </div>
                <div className="col-md-1">
                  <button className="btn btn-primary" onClick={handleSearch}>
                    Search
                  </button>
                </div>
                <div className="col text-right">
                  <PermissionsGate scopes={['export_general_ledger']}>
                    <div className="btn-group">
                      <button
                        className="btn btn-info dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Export
                      </button>
                      <div className="dropdown-menu dropdown-menu-right">
                        <button
                          className="dropdown-item"
                          onClick={onHandlegeneralLedgerExport}
                        >
                          Export
                        </button>
                        <button
                          className="dropdown-item"
                          onClick={onHandleGlExportDownload}
                        >
                          Long Export
                        </button>
                      </div>
                    </div>
                  </PermissionsGate>
                </div>
              </div>
            </PermissionsGate>
            {/* <div className="col-md-1 text-right">
                  <label>&nbsp;</label>
                  <div>
                    <PermissionsGate
                      scopes={["export_receivable_sub_ledger_list"]}
                    >
                      <button
                        className=" btn btn-success"
                        onClick={handleExport}
                      >
                        Export
                      </button>
                    </PermissionsGate>
                  </div>
                </div> */}
            <br />
            <PermissionsGate
              scopes={['get_general_ledger']}
              RenderError={AlertDefaultError}
            >
              <PrimaryDataTable
                rows={generalLedgerData}
                columns={generalLedgerCol}
                // columnVisibilityModel={{
                //   running_balance: columnRunning,
                // }}
                getRowId={(row) => row.id}
                rowCount={totalRow}
                loading={loading}
                reload={reloadTable}
                mode="server"
                onChange={handleTableChange}
                filterMode="server"
                onFilterModelChange={handleFilterModelChange}
              />
            </PermissionsGate>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default GeneralLedgerReportScreen;
